import React from "react";
import {
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@material-ui/core";
import { Field } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { fillAgentFormField } from "../store/agent-form.slice";
import { AppState } from "../../../store";
import { createAgentsStyles } from "../create/create-agents.styles";
import useAuthority from "app/hooks/useAuthority";
import { ROLES } from "app/constants/roles";


const DebtInfo = () => {
  const dispatch = useDispatch();
  const agentForm = useSelector((state: AppState) => state.agents.agentForm);
  const classes = createAgentsStyles();
  const { t } = useTranslation();
  const {hasUserAnyAuthority} = useAuthority();
  const isAdmin = hasUserAnyAuthority([ROLES.ROLE_ADMIN]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (!isAdmin) return;

    const name = e.target.name;
    const value =
      name === "debtBeforeEnding" ? parseInt(e.target.value || "0", 10) : e.target.value;

    dispatch(
      fillAgentFormField({
        value,
        field: name,
      })
    );
  };

  const preventInvalidNumberInput = (
    e: any
  ) => {
    if (
      e.key === "-" ||
      e.key === "e" ||
      e.key === "E" ||
      e.code === "Minus"
    ) {
      e.preventDefault();
    }
  };

  return (
    <div style={{ margin: "10px 0" }}>
      <Grid container spacing={4}>
        <Grid item xs={7}>
          <div
            className={classes.radioGroupDiv}
            role="group"
            aria-labelledby="my-radio-group"
          >
            <Typography style={{ marginBottom: ".5rem" }}>
              {t(
                "app.main.agency.create.debtInfo.label1",
                "Llogarit borxhin aktual:"
              )}
            </Typography>

            <label style={{ marginRight: "16px" }}>
              <Field
                type="radio"
                name="actualDebt"
                checked={agentForm.actualDebt === "ONE SEGMENT"}
                value="ONE SEGMENT"
                onChange={handleChange}
                disabled={!isAdmin}
              />
              {t("app.main.agency.create.debtInfo.label2", "A segment")}
            </label>

            <label style={{ marginRight: "16px" }}>
              <Field
                type="radio"
                name="actualDebt"
                checked={agentForm.actualDebt === "TWO SEGMENTS"}
                value="TWO SEGMENTS"
                onChange={handleChange}
                disabled={!isAdmin}
              />
              {t("app.main.agency.create.debtInfo.label3", "Two segments")}
            </label>

            <label>
              <Field
                type="radio"
                name="actualDebt"
                checked={agentForm.actualDebt === "TOTAL"}
                value="TOTAL"
                onChange={handleChange}
                disabled={!isAdmin}
              />
              {t(
                "app.main.agency.create.debtInfo.label4",
                "Total obligation"
              )}
            </label>
          </div>
        </Grid>

        <Grid item xs={5}>
          <Field
            as={TextField}
            style={{ width: "100%" }}
            label={t(
              "app.main.agency.create.debtInfo.label5",
              "Calculate the debt before completion"
            )}
            onChange={handleChange}
            value={agentForm.debtBeforeEnding || ""}
            variant="outlined"
            size="small"
            name="debtBeforeEnding"
            type="number"
            disabled={!isAdmin}
            onKeyDown={preventInvalidNumberInput}
            InputProps={{
              inputProps: { min: 0 },
              endAdornment: (
                <InputAdornment position="start">Orë</InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default DebtInfo;